// Storage del contesto per flusso asincrono su Node: `AsyncLocalStorage` tiene lo
// scope della richiesta corrente separato da quello delle richieste concorrenti
// (CYJS-7). Nel browser non esiste (ed è inutile: single-thread) → `undefined`, e
// il `Client` ricade su un semplice stack sincrono.
//
// `async_hooks` NON è importato staticamente: romperebbe il bundle browser (l'IIFE
// `<script>` non ha i builtin Node). È risolto a runtime via
// `process.getBuiltinModule`, che il bundler non linka e che il browser non
// raggiunge mai (gate `isNode`) — stessa guardia di `nodeOs` in `runtime.ts`.
// Richiede Node ≥20.16, il minimo dichiarato in `engines` (vedi `package.json`).

import { isNode } from './runtime'
import type { Scope } from './scope'

/// Sottoinsieme di `AsyncLocalStorage` usato dal client (evita la dipendenza dai
/// tipi `@types/node` nella firma pubblica e mantiene il modulo isomorfo).
export interface ScopeStorage {
  getStore(): Scope | undefined
  run<T>(store: Scope, callback: () => T): T
}

interface AsyncLocalStorageCtor {
  new (): ScopeStorage
}

interface AsyncHooks {
  AsyncLocalStorage?: AsyncLocalStorageCtor
}

interface ProcessWithBuiltin {
  getBuiltinModule?: (id: string) => unknown
}

/// Crea lo storage per lo scope su Node, o `undefined` nel browser / se
/// `async_hooks` è irraggiungibile (difesa in profondità: mai un crash).
export function createScopeStorage(): ScopeStorage | undefined {
  if (!isNode()) return undefined
  try {
    const ctor = nodeAsyncHooks()?.AsyncLocalStorage
    return typeof ctor === 'function' ? new ctor() : undefined
  } catch {
    return undefined
  }
}

function nodeAsyncHooks(): AsyncHooks | undefined {
  const getBuiltin = (process as ProcessWithBuiltin).getBuiltinModule
  if (typeof getBuiltin !== 'function') return undefined
  return getBuiltin('async_hooks') as AsyncHooks
}
